import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 7l8 10m-8 0l8 -10","key":"svg-0"}],["path",{"d":"M21 11h-4l3.5 -4a1.73 1.73 0 0 0 -3.5 -2","key":"svg-1"}]]

/**
 * IconSuperscript
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc3VwZXJzY3JpcHQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTUgN2w4IDEwbS04IDBsOCAtMTAiIC8+CiAgPHBhdGggZD0iTTIxIDExaC00bDMuNSAtNGExLjczIDEuNzMgMCAwIDAgLTMuNSAtMiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/superscript
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconSuperscript = createReactComponent('outline', 'superscript', 'Superscript', __iconNode);

export default IconSuperscript;